import { render } from "./EventList.vue?vue&type=template&id=ce71ec40&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=ce71ec40&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ce71ec40"

export default script